var useSyncExternalStoreWithSelector_production = {};
export {
  useSyncExternalStoreWithSelector_production as __exports
};
//# sourceMappingURL=use-sync-external-store-with-selector.production.js.map
